import { Vehicle } from 'core/models/vehicle';
import { Environment } from 'core/models/environment';
import { Project } from 'core/models/project';
import { useState, useEffect } from 'react';
import { useVehicleRepository } from './useVehicleRepository';
import { cancellable } from './utility/cancellable';

export function useVehicle(vehicleId: Vehicle.Id, projectId: Project.Id, environmentId: Environment.Id) {
    const [vehicle, setVehicle] = useState<Vehicle>();

    const vehicleRepository = useVehicleRepository();

    useEffect(() => {
        return cancellable(async isCancel => {
            if (!vehicleRepository) {
                console.error(`cannot obtain channel layout for vehicle ${vehicleId} due to the lack of required dependencies (VehicleRepository)\ncheck out your DI settings.`);
            }

            try {
                const vehicle = await vehicleRepository.getVehicle(vehicleId, projectId, environmentId);
                if (isCancel()) return;
                setVehicle(vehicle);
            } catch (e) {
                console.error(`cannot obtain vehicle ${vehicleId} due to: ${JSON.stringify(e)}`);
            }
        });
    }, [vehicleId, projectId, environmentId, vehicleRepository]);

    return vehicle;
}
